<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    failIds?: string[];
    /** When true, duplicate ids are shown once. */
    unique?: boolean;
  }>(),
  {
    failIds: () => [],
    unique: true,
  },
);

const uniqueFailIds = computed(() => {
  return props.unique ? [...new Set(props.failIds)] : props.failIds;
});

</script>

<template>
  <div v-if="uniqueFailIds.length > 0" class="error-fail-ids--container">
    <span v-for="failId in uniqueFailIds" :key="failId" class="error-fail-id">
      {{ failId }}
    </span>
  </div>
</template>

<style scoped lang="less">
@import '../../../assets/style/variables.less';

.error-fail-ids--container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;

  .error-fail-id {
    border: 1px solid @color-mid-green;
    color: @color-primary;
    background-color: @color-background-dark;
    border-radius: 10px;
    padding: 2px 10px;
  }
}
</style>